module.exports = __webpack_public_path__ + "static/media/miramella_alpina.1e460ee8.jpg";